import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';

import MessageBox from 'Components/Utility/MessageBox';
import Meta from 'Components/Utility/SEO/Meta';
import NoIndex from 'Components/Utility/SEO/NoIndex';

const AccountConfirm = ({ match, accountConfirm, confirm, intl: { formatMessage } }) => {
  useEffect(() => {
    const { token1, token2, date } = match.params;
    accountConfirm(token1, token2, date);
  }, [match, accountConfirm]);

  const messages = defineMessages({
    title: {
      id: 'account-confirm.title',
      defaultMessage: 'Account Confirm',
    },
    account_confirm: {
      id: 'account-confirm.account-confirm',
      defaultMessage: 'Thank you. Your account has been confirmed',
    },
  });

  return (
    <React.Fragment>
      <Meta brandTitle title={formatMessage(messages.title)} />
      <NoIndex />
      <div className="fanatical-general-page">
        <div className="container">
          <div className="fanatical-general-page-content">
            <h1>
              <FormattedMessage id="account-confirm.header.confirm" defaultMessage="Account Confirm" />
            </h1>
            <hr />
            <h4>
              <FormattedMessage id="account-confirm.registering" defaultMessage="Thank you for registering with Fanatical" />
            </h4>
            {confirm.status !== 0 && confirm.status !== 99 &&
              <div className="mt-4">
                <MessageBox
                  type="error"
                  title="Error"
                  message={confirm.error}
                />
              </div>
            }
            {confirm.status === 99 &&
              <div className="mt-4">
                <MessageBox
                  type="success"
                  title="Success"
                  message={formatMessage(messages.account_confirm)}
                />
              </div>
            }
            <div className="cta-group-container mt-4">
              <div className="cta-container">
                <Link to="/orders" className="btn btn-primary">
                  <FormattedMessage id="account-confirm.view-orders" defaultMessage="View your Fanatical orders" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

AccountConfirm.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      token1: PropTypes.string,
      token2: PropTypes.string,
      date: PropTypes.string,
    }),
  }),
  accountConfirm: PropTypes.func,
  confirm: PropTypes.shape({
    error: PropTypes.string,
    status: PropTypes.number,
  }),
};

AccountConfirm.defaultProps = {
  match: ({
    params: {
      token1: '',
      token2: '',
      date: '',
    },
  }),
  accountConfirm: () => { },
  confirm: ({
    error: '',
    status: 0,
  }),
};

export default injectIntl(AccountConfirm);
